"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _TopHands = _interopRequireDefault(require("./TopHands"));
var _Promotions = _interopRequireDefault(require("./Promotions"));
var _Discord = _interopRequireDefault(require("./Discord"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _ = require("lodash");
var PotsNPromotions = /*#__PURE__*/function (_React$Component) {
  _inherits(PotsNPromotions, _React$Component);
  var _super = _createSuper(PotsNPromotions);
  function PotsNPromotions(props) {
    var _this;
    _classCallCheck(this, PotsNPromotions);
    _this = _super.call(this, props);
    _this.state = {
      openHandRep: false,
      promotionTitle: "",
      promotionUrl: "",
      webLink: "",
      content: "",
      loading: true,
      playFlag: true,
      gameNo: "",
      partitionDate: "",
      repoSetting: {},
      potsLoading: false
    };
    return _this;
  }
  _createClass(PotsNPromotions, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var repoSetting = this.state.repoSetting,
        topHands = [{
          handList: this.props.playerReports.topHands.topWonHands,
          handListType: "won"
        }, {
          handList: this.props.playerReports.topHands.topLostHands,
          handListType: "lost"
        }];
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pots"
      }, topHands.map(function (wonNLostHands) {
        return /*#__PURE__*/_react["default"].createElement(_TopHands["default"], {
          isLiveview: _this2.props.isLiveview,
          hands: wonNLostHands.handList,
          gameType: _this2.props.gameType,
          handListType: wonNLostHands.handListType,
          handReplayerOpen: function handReplayerOpen(item, lossOrwon) {
            return _this2.props.handReplayerOpen(item, lossOrwon);
          }
        });
      })), this.props.promotionalContent ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_Promotions["default"], {
        promotionalContent: this.props.promotionalContent
      }), /*#__PURE__*/_react["default"].createElement(_Discord["default"], null)) : null);
    }
  }]);
  return PotsNPromotions;
}(_react["default"].Component);
var _default = PotsNPromotions;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/PotsNPromotions.js
 ** module id = 2394
 ** module chunks = 0
 **/